<template>
  <v-row>
    <v-col xl="8" class="mx-auto">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col cols="6" sm="3">
              <v-select
                :items="types"
                v-model="type"
                :label="$t('門號類型')"
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="6" sm="3">
              <v-select
                :items="statusOptions"
                v-model="status"
                :label="$t('狀態')"
                dense
                hide-details
              ></v-select>
            </v-col>

            <v-col cols="12" sm="4" class="ml-auto">
              <v-text-field
                v-model="search"
                :label="$t('快速搜尋')"
                dense
                single-line
                hide-details
                append-icon="mdi-magnify"
                @click:append="onSearch"
                @keydown.enter="onSearch"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <v-data-table
          :loading="isLoading"
          :headers="headers"
          :items="results"
          :mobile-breakpoint="0"
          :items-per-page="15"
          :disable-sort="$vuetify.breakpoint.smAndDown"
          :options.sync="options"
          :footer-props="footerProps"
          class="text-no-wrap"
          @click:row="editApplication"
        >
          <template v-slot:item.created_at="{ item }">
            {{ item.created_at | date('YYYY/MM/DD') }}
          </template>
          <template v-slot:item.type="{ item }">
            {{ typesMapping[item.type] }}
          </template>
          <template v-slot:item.identity_no="{ item }">
            {{ item.order_no ? '***' : item.identity_no }}
          </template>
          <template v-slot:item.agency="{ item }">
            {{ item.vendor_agent ? item.vendor_agent.name : item.agency }}
          </template>
          <template v-slot:item.sim.phone="{ item }">
            {{ item.sim.phone }}
            <v-chip
              v-if="item.phone_count == 2"
              small
            >{{ $t("第2門") }}</v-chip>
          </template>
          <template v-slot:item.nationality="{ item }">
            {{ NATIONALITY_VALUE_MAPPINGS[item.nationality] }}
          </template>
          <template v-slot:item.current_issue.type="{ item }">
            {{ item.order_no ? '-' : $t(item.current_issue ? item.current_issue.type : null) }}
          </template>
          <template v-slot:item.status="{ item }">
            <status-chip v-if="item.order_no" :status="APPLICATION_STATUS.PROVISIONED"></status-chip>
            <status-chip v-else :status="item.status"></status-chip>
          </template>
          <template v-slot:item.flight.status="{ item }">
            <flight-status-chip v-if="item.flight" :status="item.flight.status" localized/>
            <span v-else>-</span>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { date } from '../../libs/filters';
import { pagination } from '../../libs/mixins';
import { mapActions, mapState, mapGetters } from 'vuex';
import StatusChip from '../../components/StatusChip';
import FlightStatusChip from '../../admin/components/FlightStatusChip';
import { APPLICATION_STATUS, NATIONALITY_VALUE_MAPPINGS } from '../../libs/const';

export default {
  mixins: [
    pagination,
  ],

  filters: {
    date,
  },

  components: {
    StatusChip,
    FlightStatusChip,
  },

  data() {
    return {
      APPLICATION_STATUS,
      NATIONALITY_VALUE_MAPPINGS,
      isLoading: false,
      search: null,
      status: null,
      // dates: [
      //   moment().subtract(3, 'months').format('YYYY-MM-DD'),
      //   moment().format('YYYY-MM-DD')
      // ],
      type: 'apply',
      typesMapping: {
        apply: this.$t('一般門號'),
        upgrade: this.$t('升級'),
        change: this.$t('換補卡'),
      },
    };
  },

  computed: {
    headers() {
      return [
        { text: this.$t("日期"), value: 'created_at', width: '20%' },
        ...(this.isAbroad ? [
          { text: this.$t("仲介名"), value: 'agency' },
          { text: this.$t("備註"), value: 'note' },
          { text: this.$t("落地日期"), value: 'provision_date' },
          { text: this.$t("班機"), value: 'flight.name' },
          { text: this.$t("聯絡電話"), value: 'phone' },
        ] : [{ text: this.$t("備註"), value: 'note' }]),
        { text: this.$t("認證電話"), value: 'vendor_member.phone', sortable: false },
        { text: this.$t("證號"), value: 'identity_no' },
        { text: this.$t("門號"), value: 'sim.phone', sortable: false },
        { text: this.$t("卡號"), value: 'sim.card_no', sortable: false },
        { text: this.$t("狀態"), value: 'status' },
        { text: this.$t("問題件類型"), value: 'current_issue.type', sortable: false },
        { text: this.$t("門號類型"), value: 'type' },
      ];
    },

    types() {
      return [
        {
          text: this.$t('一般門號'),
          value: 'apply',
        },
        // {
        //   text: $t('升級'),
        //   value: 'upgrade',
        // },
        // {
        //   text: $t('換補卡'),
        //   value: 'change',
        // },
      ];
    },

    statusOptions() {
      return [
        {
          text: this.$t('全部'),
          value: null,
        },
        {
          text: this.$t('暫存'),
          value: APPLICATION_STATUS.ON_HOLD,
        },
        {
          text: this.$t('已送件'),
          value: [APPLICATION_STATUS.SUBMITTED, APPLICATION_STATUS.IN_PROGRESS].join(','),
        },
        {
          text: this.$t('預計開通'),
          value: [APPLICATION_STATUS.PENDING_PROVISION].join(','),
        },
        {
          text: this.$t('已開通'),
          value: [
            APPLICATION_STATUS.PROVISIONED,
            APPLICATION_STATUS.HAS_ISSUE,
            APPLICATION_STATUS.SUSPENDED,
            APPLICATION_STATUS.RETURNED,
          ].join(','),
        },
        {
          text: this.$t('問題件'),
          value: APPLICATION_STATUS.HAS_ISSUE,
        },
      ];
    },

    results() {
      if (this.status == this.statusOptions[4].value) {
        return this.items.filter(application => application.order_no != null);
      }

      if (this.status == APPLICATION_STATUS.HAS_ISSUE) {
        return this.items.filter(application => application.order_no == null);
      }

      return this.items;
    },


    ...mapGetters(['isAbroad']),

    ...mapState('applications', {
      items: 'all',
      filterOptions: 'filterOptions',
    }),
  },

  watch: {
    type() {
      this.fetchAll();
    },

    status() {
      this.fetchAll();
    }
  },

  beforeRouteLeave (to, from, next) {
    this.setFilterOptions({...this.options, ...{
      search: this.search,
      type: this.type,
      status: this.status,
    }});
    next();
  },

  created() {
    if (this.filterOptions) {
      this.search = this.filterOptions.search;
      this.type = this.filterOptions.type;
      this.status = this.filterOptions.status;
      this.options = this.filterOptions;
    }
  },

  async mounted() {
    this.isLoading = true;
    this.clearApplications();
    this.fetchAll(this.filterOptions);
    this.isLoading = false;
  },

  methods: {
    editApplication(item) {
      this.$router.push({
        name: 'apply',
        params: {
          id: item.id
        }
      });
    },

    queryResults(options) {
      return this.getApplications({...options, ...{
        search: this.search,
        type: this.type,
        status: this.status,
        withData: ['vendorMember'],
        // 'between:created_at': this.dates,
      }});
    },

    ...mapActions('applications', {
      getApplications: 'get',
      clearApplications: 'clear',
      setFilterOptions: 'setFilterOptions',
    }),
  }
}
</script>
